import type { GoogleAdsUserData } from '../../analytics/googleAdsUserData';

export const GTG_EVENTS = {
  PURCHASE: 'FL_Web_Purchase_GTG',
  OB_STARTED: 'FL_Web_OB_Started_GTG',
} as const;

interface GtgOnboardingStartedEvent {
  event: typeof GTG_EVENTS.OB_STARTED;
}

interface GtgPurchaseEvent {
  event: typeof GTG_EVENTS.PURCHASE;
  value: number;
  currency: string;
  transaction_id: string;
  items: Array<{
    item_id: string;
    item_name: string;
  }>;
  gclid?: string;
  user_data?: GoogleAdsUserData;
}

export type GtgEventPayload = GtgOnboardingStartedEvent | GtgPurchaseEvent;

export const pushGtgEvent = (payload: GtgEventPayload): void => {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};
